<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox></navBox>
			<!--导航-->
			<!--协议内容-->
			<div
				data-aos="fade-up"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="content_box"
			>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;text-align: center">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 27px">
							Terms and Conditions
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin: 0 0 15px;text-align: justify">
					<span style="font-family: Helvetica">
						&nbsp;
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Welcome to the UC reagent website. The following terms and conditions
						(the &quot;Terms&quot;, &quot;Agreement&quot;) outlined herein constitute
						a legally binding agreement between you and UC reagent.
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						(&quot;UC reagent&quot;,
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						 &quot;we&quot;, &quot;our&quot; or &quot;us&quot;) and govern your
						access and use of the UC reagent website at
					</span>
					<a href="https://ucreagent.com/">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(5, 99, 193)">
								www.ucreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						(the
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&quot;Website&quot;).
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						By accessing and/or using the Website, you represent and warrant that
						you can enter into the Agreement and abide by all of the terms and conditions
						set forth herein. You may not access or use this Website, subscribe to
						our newsletter, or accept this Agreement unless you agree with the terms
						herein. If you do not agree with all provisions of this Agreement, please
						do not access and/or use the Website, sign up for our newsletter, or contact
						us.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Certain services we provide to you may be subject to additional terms,
						and such additional terms will be presented to you when you use such service.
						If the terms and conditions herein this Agreement are inconsistent with
						the additional terms, the provisions of the additional terms shall be superior
						and shall control with respect to such additional service and your use
						thereof. The additional terms, upon acceptance, are incorporated into these
						Terms.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Throughout these Terms, we use &quot;UC reagent&quot;, &quot;we&quot;, &quot;us&quot;
						and &quot;our&quot; to refer to
					</span>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;">
							UC reagent, Inc.
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;offering our Website to you. &quot;You&quot; refers to you as an
						individual who makes use of the UC reagent Website.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times Roman&#39;">
							IMPORTANT ARBITRATION NOTICE:
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						THESE TERMS CONTAIN AN ARBITRATION CLAUSE AFFECTING YOUR LEGAL RIGHTS.
						PLEASE READ THE ARBITRATION CLAUSE CAREFULLY, AS IT REQUIRES YOU TO ARBITRATE
						DISPUTES WITH UC reagent ON AN INDIVIDUAL BASIS, LIMITS YOUR ABILITY TO SEEK
						RELIEF IN A COURT OF LAW, AND WAIVES YOUR RIGHT TO PARTICIPATE IN CLASS
						ACTIONS OR CLASS ARBITRATIONS.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							1.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Modification of these Terms
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We reserve the right to make changes to this Agreement at any time and
						at our discretion. If you disagree with such changes, you should cease
						using the website. Your continued use of the website after any such changes
						to the Terms shall be deemed acceptance of any such new or modified terms.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The contents of this Website may also include technical inaccuracies or
						typographical errors. We may publish changes to the contents without prior
						notice to you. We shall have the right to revise and edit these contents
						at any time. By linking, accessing, browsing, and/or using this Website,
						you agree to be bound by any such revisions.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Also, because our services are evolving, we may change or discontinue
						all or any part of the Website, at any time and without notice, at our
						sole discretion.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							2.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Use of the website
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The website allows you to learn about UC reagent business, view information
						about products and services that are offered, contact us to ask questions
						or schedule consultations, potentially conduct business transactions, and
						engage with us in other ways enabled through the website. Your use must
						comply with these Terms and all applicable local, state, federal, and international
						laws, rules, and regulations.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							3.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Intellectual property, copyright, and license
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;">
							Intellectual property:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						All the resources and content included on the Website, including, but
						not limited to, images, code, illustrations, text, scripts, graphics, audio
						clips, video clips, documentation, and other interactive features made
						available to you on the Website, logos, trademarks, and service marks contained
						herein, are owned by UC reagent or its licensors.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Other service marks, logos, and names on this Website are the property
						of their respective owners. Any use of the Website or the contents made
						available to you through the Website other than as specifically authorized
						herein without our prior written permission is strictly prohibited and
						will terminate the license granted herein. Such unauthorized use may also
						violate applicable laws, including, without limitation, copyright and trademark
						laws and applicable communications regulations and statutes.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Unless explicitly stated herein, nothing in this Agreement shall be construed
						as conferring any license to intellectual property rights, whether by estoppel,
						implication, or otherwise. This license is revocable by UC reagent at any time
						without notice and with or without cause. Despite the foregoing, we make
						no claim to the trademarks, copyrights, patents, or other intellectual
						property contained in certain third-party features, which are entirely
						the property of its owner, assignees, and licensees.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="text-decoration:underline;">
						<span style="font-family: &#39;Times Roman&#39;">
							License and restrictions:
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Subject to your compliance with the terms herein, we grant you a limited,
						non-exclusive, non-sublicensable, revocable, non-transferable license to
						access and use the Website subject to the Terms of this Agreement. Any
						rights not expressly granted herein are reserved by us.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You may not: (i) remove any copyright, trademark, or other proprietary
						notices from any portion of the Website; (ii) reproduce, modify, prepare
						derivative works based upon, distribute, license, lease, sell, resell,
						transfer, publicly display, publicly perform, transmit, stream, broadcast
						or otherwise exploit the Website except as expressly permitted by us; (iii)
						decompile, reverse engineer or disassemble the Website except as may be
						permitted by applicable law; (iv) link to, mirror or frame any portion
						of the Website; or (v) cause or launch any programs or scripts for the
						purpose of scraping, indexing, surveying, or otherwise data mining any
						portion of the Website or unduly burdening or hindering the operation and/or
						functionality of any aspect of the Website.
					</span>
				</p>	
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							4.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Professional/Medical disclaimer
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You understand and agree that your use of the website and/or any information
						or content included on or transmitted through the UC reagent Website is not
						intended to and will not create any professional or patient relationship
						of any kind between you and UC reagent or its affiliates.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						The website provides information that is intended for general educational
						and informational purposes only and should not be interpreted as personalized
						medical advice. Neither the Content nor resources on any part of the Website
						are intended to be substituted for medical diagnosis or treatment of any
						form. Users should always consult with qualified healthcare providers for
						specifics related to any medical questions, diagnoses, treatments, medications,
						products, or interventions. Reliance on any information on the website
						is strictly at users&#39; risk.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						UC reagent disclaims any liability for the accuracy of any information or
						Content provided or sent by you or other users of the Website. You shall
						be responsible for verifying the accuracy of any information you send or
						receive through the Website.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						UC reagent makes the Website available to users for the purpose of providing
						an informative and educational resource. UC reagent may, but has no obligation
						to, review Content posted on the Website. UC reagent does not guarantee the
						timeliness and accuracy of any or all the Content. UC reagent disclaims liability
						for any errors or omissions or for the results obtained from the use of
						such Content.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							5.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Copyright infringement notification (DMCA)
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						We respect the intellectual property of others and ask users of our website
						to do the same. Our website may not be used to transmit, retransmit, distribute,
						post, or store any material that violates any person&#39;s rights, including
						rights protected by copyright, trade secret, patent, or other intellectual
						property or similar laws or regulations.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						If you believe that your copyrighted work has been copied and is accessible
						on our website in a way that constitutes copyright infringement, please
						notify us by sending us an email at
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<a href="mailto:info@UCreagent.com">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(5, 99, 193)">
								info@UCreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						In order to be valid, the notification must be in writing and must contain
						the following information:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<span style="font-family: &#39;Times New Roman&#39;">
						i.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						a description of the copyrighted content or other intellectual property
						that you claim has been infringed;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<span style="font-family: &#39;Times New Roman&#39;">
						ii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						a statement by you that you have a good faith belief that the use of this
						content or intellectual property is not authorized and for which reason;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<span style="font-family: &#39;Times New Roman&#39;">
						iii.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						a detailed description of where this content or intellectual property
						is located on the website, in order for us to find it;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<span style="font-family: &#39;Times New Roman&#39;">
						iv.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						your address, telephone number, and email address;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<span style="font-family: &#39;Times New Roman&#39;">
						v.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						a signature of the person authorized to act on behalf of the owner of
						the copyright or other intellectual property interest;
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<span style="font-family: &#39;Times New Roman&#39;">
						vi.
					</span>
					<span style="font-family: &#39;Times New Roman&#39;">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						a statement by you, made under penalty of perjury, that the above information
						provided by you in the notification is accurate and that you are the copyright
						or intellectual property owner or authorized to act on behalf of the copyright
						or intellectual property owner.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Please note that (i) any person who knowingly misrepresents to UC reagent
						that material is infringing shall be liable to UC reagent and/or the alleged
						infringer for any damages (including costs and attorneys&#39; fees) suffered
						or incurred by UC reagent and/or the alleged infringer as a result of UC reagent
						reliance on such misrepresentation and removing or disabling access to
						such material. ii) Similarly, any person who knowingly misrepresents to
						UC reagent that the material was removed or access blocked by mistake or misidentification
						shall be liable to UC reagent and/or the copyright owner or its authorized
						licensee for any damages (including costs and attorneys&#39; fees) suffered
						or incurred by UC reagent and/or the copyright owner or its authorized licensee
						as a result of UC reagent reliance on such misrepresentation and replacing
						such removed or blocked material.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							6.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Prohibited ways in which you cannot make use of our website
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You may not access or use the website for any purpose other than that
						for which we make the service available. The website may not be used in
						connection with any commercial endeavors except those that are specifically
						endorsed or approved by us.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						As a user of the website, you agree not to:
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							i
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Systematically retrieve data or other content from the website to create
						or compile, directly or indirectly, a collection, compilation, database,
						or directory without written permission from us.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							ii
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Trick, defraud, or mislead us and other users, especially in any attempt
						to learn sensitive account information such as user passwords.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							iii
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Circumvent, disable, or otherwise interfere with security-related features
						of the website, including features that prevent or restrict the use or
						copying of any content or enforce limitations on the use of the website
						and/or the Content contained therein.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							iv
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Disparage, tarnish, or otherwise harm, in our opinion, us and/or the website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							v
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Use any information obtained from the website in order to harass, abuse,
						or harm another person.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							vi
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Make improper use of our support services or submit false reports of abuse
						or misconduct.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							vii
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Use the website in a manner inconsistent with any applicable laws or regulations.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							viii
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Upload or transmit (or attempt to upload or to transmit) viruses, Trojan
						horses, or other material, including excessive use of capital letters and
						spamming (continuous posting of repetitive text), that interferes with
						any party&#39;s uninterrupted use and enjoyment of the website or modifies,
						impairs, disrupts, alters, or interferes with the use, features, functions,
						operation, or maintenance of the website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							ix
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Engage in any automated use of the system, such as using scripts to send
						comments or messages or using any data mining, robots, or similar data
						gathering and extraction tools.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							x
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Delete the copyright or other proprietary rights notice from any Content.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							xi
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Attempt to impersonate another user or person or use the username of another
						user.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							xii
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Upload or transmit (or attempt to upload or to transmit) any material
						that acts as a passive or active information collection or transmission
						mechanism, including, without limitation, clear graphics interchange formats
						(&quot;gifs&quot;), 1
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						<span style="font-family:Times Roman">
							×
						</span>
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						1 pixels, web bugs, cookies, or other similar devices (sometimes referred
						to as &quot;spyware&quot; or &quot;passive collection mechanisms&quot;
						or &quot;pcms&quot;).
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							xiii
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Interfere with, disrupt, or create an undue burden on the website or the
						networks or services connected to the website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							xiv
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Harass, annoy, intimidate, or threaten any of our employees or agents
						engaged in providing any portion of the website to you.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							xv
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Attempt to bypass any measures of the website designed to prevent or restrict
						access to the website or any portion of the website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							xvi
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Decipher, decompile, disassemble, or reverse engineer any of the software
						comprising or in any way making up a part of the website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							xvii
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Except as may be the result of a standard search engine or Internet browser
						usage, use, launch, develop, or distribute any automated system, including,
						without limitation, any spider, robot, cheat utility, scraper, or offline
						reader that accesses the website, or using or launching any unauthorized
						script or other software.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 96px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							xviii
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Make any unauthorized use of the website, including collecting users&#39;
						email addresses by electronic or other means to send unsolicited emails.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							7.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Feedback and comments
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You may voluntarily post, submit, or otherwise communicate to us any questions,
						comments, suggestions, ideas, original or creative materials, or other
						information about UC reagent or our Services (collectively, &quot;Feedback&quot;).
						You understand that we may use such feedback for any purpose, commercial
						or otherwise, without acknowledgment or compensation to you, including,
						without limitation, to develop, copy, publish, or improve our Services
						by using the feedback at our sole discretion.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You understand that your feedback content shall be considered non-confidential
						and non-proprietary and that by posting, inputting, uploading, sharing,
						providing, or otherwise submitting any feedback content to our website,
						we will treat such feedback content as non-confidential. User hereby grants
						UC reagent, its affiliates, and marketing partners a worldwide, non-exclusive,
						royalty-free, perpetual, irrevocable right, sublicensable (through multiple
						tiers), and transferable right and license to reproduce, use, publish,
						distribute, translate, reformat, transmit, display, modify, create derivative
						works of and otherwise commercially exploit (including but not limited
						to over the Internet, broadcast television or any other uses or media {including
						any or all existing and future social media platforms}) such feedback,
						in whole or in part, including existing and future rights that UC reagent (or
						its successor) may otherwise become entitled to that do not yet exist,
						as well as new uses, media, means, and forms of exploitation throughout
						the universe exploiting current or future technology yet to be developed
						in the future all Content in connection with your access and use of the
						UC reagent Services.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							8.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Third-party links and resources
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Some links on the Website may allow you to leave the Website. The linked
						Websites or resources are not in any way under our control, and we are
						not responsible for the contents of any of such linked Websites, any link
						contained in a linked Website, or any changes or updates to such Websites.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							9.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Privacy
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						When accessing and/or using the Website and the Services we offer, we
						may obtain certain information about you, or you may be required to provide
						certain information to us. All uses of your information will be treated
						in accordance with our Privacy Policy, which herein forms an integral part
						of these Terms. Please refer to our Privacy Policy for information on how
						we collect, use, and disclose information from our users.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							10.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Disclaimers and Warranties
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						UC reagent EXPRESSLY DISCLAIMS, TO THE FULLEST EXTENT PERMITTED BY LAW, ANY
						EXPRESS OR IMPLIED
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						WARRANTIES: (A) THAT THE WEBSITE, WEBSITE CONTENT, SERVICES, ADVICE, INFORMATION
						OR LINKS PROVIDED OR
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						DISPLAYED ON THE WEBSITE WILL MEET YOUR REQUIREMENTS; (B) THAT THE WEBSITE
						WILL BE UNINTERRUPTED, TIMELY,
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						SECURE OR FREE FROM ERROR OR THAT ANY ERRORS WILL BE CORRECTED; (C) THAT
						DEFECTS IN THE OPERATION
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						OR FUNCTIONALITY OF THE WEBSITE, WEBSITE CONTENT, SERVICES, OR PRODUCTS
						WILL BE CORRECTED; AND
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						(D) REGARDING THE WEBSITE, USER CONTENT, WEBSITE CONTENT, SERVICES, PRODUCTS,
						ADVICE, INFORMATION OR
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						LINKS PROVIDED BY ANY THIRD PARTIES OR USERS. NO ADVICE OR INFORMATION,
						WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM THE WEBSITE SHALL CREATE
						ANY WARRANTY NOT EXPRESSLY STATED IN THESE TERMS.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						YOUR USE OF THE WEBSITE IS AT YOUR OWN RISK. THE WEBSITE IS PROVIDED ON
						AN &quot;AS IS&quot; AND &quot;WITH ALL FAULTS&quot; BASIS, WITHOUT ANY
						WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED
						TO, THE WARRANTIES OF MERCHANTABILITY, NON-INFRINGEMENT AND FITNESS FOR
						PARTICULAR PURPOSE. NEITHER UC reagent NOR ANY PERSON ASSOCIATED WITH UC reagent
						MAKES ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE WEBSITE, USER
						CONTENT, WEBSITE CONTENT, SERVICES, PRODUCTS, INFORMATION AND OTHER MATERIALS
						CONTAINED THEREIN. WITHOUT LIMITING THE FOREGOING, NEITHER UC reagent NOR ANYONE
						ASSOCIATED WITH UC reagent REPRESENTS OR WARRANTS THAT THE WEBSITE OR ITS CONTENTS
						WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT DEFECTS
						WILL BE CORRECTED, THAT THE WEBSITE OR SERVICES THAT MAKE THE WEBSITE AVAILABLE
						ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							11.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Limitation of Liability
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						UC reagent and its officers, directors, employees, suppliers or agents, exclude
						all liability and responsibility for any amount or kind of loss or damage
						that may result to you or a third party (including without limitation,
						any direct, indirect, punitive or consequential loss or damages, or any
						loss of income, profits, goodwill, data, contracts, use of money, or loss
						or damages arising from or connected in any way to website interruption,
						and whether in tort, including without limitation negligence, contract
						or otherwise) in connection with these terms and conditions or the website
						in any way (including in connection with the use, inability to use or the
						results of use of the website, any websites linked to the website or the
						material on such websites, including but not limited to loss or damage
						due to viruses that may infect your computer equipment, software, data
						or other property on account of your access to, use of, or browsing the
						website or your downloading of any material from the website or any websites
						linked to the website).
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						In no event will UC reagent total liability arising out of or in connection
						with these terms or from the use of or inability to use the website exceed
						the lesser of the total amounts you have paid to UC reagent during the six
						(6) month period immediately preceding the event(s) giving rise to such
						liability or fifty dollars ($50), if you have not had any payment obligations
						to UC reagent, as applicable. The exclusion and limitations of damages set
						forth above are fundamental elements of the basis of the bargain between
						UC reagent and you.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You agree that if you are dissatisfied with any portion of the website
						or with these terms, your sole and exclusive remedy is to discontinue your
						use of the website.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							12.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Indemnification
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You agree that as a condition of use of the Website, you will indemnify,
						defend, and hold harmless UC reagent, its officers, directors, employees, agents,
						licensors, and suppliers (collectively, the &quot;Service Providers&quot;)
						from and against any and all losses, expenses, damages and costs, including
						reasonable attorneys&#39; fees, resulting from your use of the Website
						or any product, including any claims alleging facts that if true would
						constitute a violation of these Terms or any activity related to your account
						(including negligent or wrongful conduct) by you or any other person accessing
						the Website using your account.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							13.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Choice of law and jurisdiction
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						These Terms and your use of the service are governed by and construed
						in accordance with the laws of the State of California, U.S.A., applicable
						to agreements made and to be entirely performed within the State of California,
						without regard to its conflict of law principles.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							14.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Dispute resolution; arbitration
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						To expedite dispute resolution and control the cost of any dispute, controversy,
						or claim related to this Agreement (or the breach, termination, enforcement,
						interpretation, or validity thereof) (&quot;Dispute&quot;), you, as a user
						of UC reagent Website agree to first attempt to negotiate any dispute
						(except those Disputes expressly provided below) informally with UC reagent
						for at least thirty (30) days before initiating any arbitration. Such informal
						negotiations commence upon written notice from one party to the other.
						We are available by email at
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<a href="mailto:info@UCreagent.com">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(5, 99, 193)">
								info@UCreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						to address any concerns or questions that you may have regarding your
						use of UC reagent Website.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						In the event that a dispute is not settled through the informal negotiation,
						any controversy or claim arising out of or relating to these Terms shall
						be settled by binding arbitration administered by the American Arbitration
						Association (AAA) in accordance with its comprehensive arbitration rules
						and procedures by a sole arbitrator. (The AAA Rules are available at
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<a href="http://www.adr.org/arb_med">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(5, 99, 193)">
								www.adr.org/arb_med
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						or by calling the AAA at 1-800-778-7879.) The Federal Arbitration Act
						will govern the interpretation and enforcement of this Section. Judgment
						on the arbitration award may be entered in any court having competent jurisdiction.
						Unless otherwise expressly required by applicable law, each party shall
						bear their own costs, legal and expert fees incurred in the arbitration
						irrespective of outcome.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Notwithstanding the above, we reserve the right to pursue injunction proceedings
						before any court of competent jurisdiction for the protection or enforcement
						of Our intellectual property rights arising from these Terms.
					</span>
				</p>
				<p style="font-size: medium;text-indent: 0;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 0;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						You and UC reagent agree, to the fullest extent permitted by applicable law,
						that each may bring claims against the other only in your or its individual
						capacity and not as a plaintiff or class member in any purported class
						or representative proceeding. Further, suppose the parties&#39; dispute
						is resolved through arbitration; the arbitrator may not consolidate another
						person&#39;s claims with your claims and may not otherwise preside over
						any form of a representative or class proceeding.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							15.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							General Provisions
						</span>
					</strong>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 64px;text-align: justify">
					<em>
						<span style="font-family: &#39;Times New Roman&#39;">
							(i)
						</span>
					</em>
					<em>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</em>
					<em>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Severability
						</span>
					</em>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 64px;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						If any provision of these Terms is determined by a court to be invalid,
						void, or unenforceable, the Parties agree that the remaining provisions
						of this Agreement will not be affected thereby and that this Agreement
						will, in any event, otherwise remain valid and enforceable.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 64px;text-align: justify">
					<em>
						<span style="font-family: &#39;Times New Roman&#39;">
							(ii)
						</span>
					</em>
					<em>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</em>
					<em>
						<span style="font-family: &#39;Times Roman&#39;">
							Waiver
						</span>
					</em>
					<span style="font-family: Helvetica">
						<br/></span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						No waiver of any of the provisions of this Agreement will constitute a
						continuing waiver unless otherwise expressly so provided in writing. The
						failure of either Party to enforce any of the provisions of this Agreement
						at any time will in no way be construed to be a present or future waiver
						of such provisions. We do not guarantee that we will pursue legal actions
						against all breaches of this Agreement.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 64px;text-align: justify">
					<em>
						<span style="font-family: &#39;Times New Roman&#39;">
							(iii)
						</span>
					</em>
					<em>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</em>
					<em>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Force Majeure
						</span>
					</em>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 64px;text-align: justify">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Notwithstanding the other provisions of this Agreement, if UC reagent is in
						good faith prevented from performing its obligations under this Agreement
						because of an event beyond its control, including without limitation, any
						act or omission of our third-party partners, war (declared or undeclared),
						acts of God, terrorism, earthquake, accident, explosion, fire, flood or
						pandemic, UC reagent will be relieved from performing its obligations provided
						that, it will take all reasonable steps to promptly remedy the cause of
						such delay or failure if it is in its power to do so.
					</span>
				</p>
				<p style="font-size: medium;text-wrap: wrap;margin-top: 0;margin-right: 0;margin-left: 32px;text-align: justify">
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							16.
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times New Roman&#39;">
							&nbsp;
						</span>
					</strong>
					<strong>
						<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
							Questions or complaints?
						</span>
					</strong>
				</p>
				<p style="font-size: medium; text-indent: 0px; text-wrap: wrap; margin-top: 0px; margin-right: 0px; margin-left: 0px; text-align: justify;">
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						Feedback, comments, requests for technical support, and other communications
						relating to the website and services should be directed to us. Please contact
						us at
					</span>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						&nbsp;
					</span>
					<a href="mailto:info@UCreagent.com">
						<span style="text-decoration:underline;">
							<span style="font-family: &#39;Times Roman&#39;;color: rgb(5, 99, 193)">
								info@UCreagent.com
							</span>
						</span>
					</a>
					<span style="font-family: &#39;Times Roman&#39;;letter-spacing: 0;font-variant-numeric: normal;font-variant-east-asian: normal;font-variant-alternates: normal;font-variant-position: normal;font-size: 16px">
						.
					</span>
				</p>
			</div>
			<!--协议内容-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//content_box
	.content_box{
		width: 1140px;
		margin: 80px auto;
	}
}
</style>